import { useDispatch } from 'react-redux'
import { useMutation } from 'react-query'
import { createSimCard } from '../api/sim-cards-api'
import { enqueueSnackbar } from '../actions'
import * as actions from '../../../app/network-devices/actions'

export const useSimCardsApi = ({
    locale,
    networkDeviceId = null,
    refetch = null
}) => {
    const dispatch = useDispatch()

    const { mutate, isLoading, isSuccess, isError } = useMutation(
        payload => createSimCard(payload),
        {
            onSuccess: () => {
                dispatch(
                    enqueueSnackbar({
                        message: locale.sagasMsgs.createSimCardRes,
                        options: {
                            variant: 'success'
                        }
                    })
                )

                if (networkDeviceId) {
                    dispatch(actions.networkDeviceRequest(networkDeviceId))
                }

                if (refetch) {
                    refetch()
                }
            },
            onError: () => {
                dispatch(
                    enqueueSnackbar({
                        message: locale.sagasMsgs.createSimCardEx,
                        options: {
                            variant: 'error'
                        }
                    })
                )
            }
        }
    )

    return {
        createSimCard: mutate,
        isCreatingSimCard: isLoading,
        isSimCardCreationSuccessful: isSuccess,
        isSimCardCreationError: isError
    }
}
